export const toggleChartLabel = (hidden: readonly string[], label: string) =>
  hidden.includes(label)
    ? hidden.filter((item) => item !== label)
    : [...hidden, label];

export const chartValue = (
  value: number,
  label: string,
  hidden: readonly string[],
) => (hidden.includes(label) ? null : value);

export const axisLabelName = (value: unknown) =>
  typeof value === 'string' ? value : undefined;
